import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';
import FinancialEdits from './components/FinancialEdits';
import HelpDesk from './components/HelpDesk';
import HelpDesks from './components/HelpDesks';
import HelpDesks7DayMissing from './components/HelpDesks7DayMissing';
import HelpDesksRandom from "./components/HelpDesksRandom";
import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';
import HelpDesksCashCheck from "./components/HelpDesksCashCheck";
import HelpDesksContacted from "./components/HelpDesksContacted";
import HelpDesksUnfiltered from "./components/HelpDesksUnfiltered";
import WoClearCodes from "./components/WoClearCodes";
import SchedulesComponent from "./components/HelpdeskSchedules";
import FePerformance from "./components/FePerformance";
import MissingFinancial from "./components/MissingFinancial";
import TicketAudit from "./components/TicketAudit";
import TicketAudits from "./components/TicketAudits";


export default ({match, regions,roles}) => (
	<div>
		<Switch>

			<ErrorBoundaryRoute exact path={`${match.url}/cash_check`}>
				<HelpDesksCashCheck regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}`}>
				<HelpDesks regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/fe_performance`}>
				<FePerformance regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/missing_financial`}>
				<MissingFinancial regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/missing`}>
				<HelpDesks7DayMissing regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/random`}>
				<HelpDesksRandom regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/contacted`}>
				<HelpDesksContacted regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/unfiltered`}>
				<HelpDesksUnfiltered regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/overrides`}>
				<WoClearCodes regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute path={`${match.url}/financialedits`}>
				<FinancialEdits regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute path={`${match.url}/helpdeskschedules`}>
				<SchedulesComponent regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/audit`}>
				<TicketAudits regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/audit/:id`}>
				<TicketAudit regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/:id`}>
				<HelpDesk regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute>
				<Redirect to={`${match.url}`} />
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);
